export default "__VITE_ASSET__6968c14c__"